import(/* webpackMode: "eager" */ "/codebuild/output/src2734558642/src/src/app/global-error.tsx");
